import React from "react";
import ad1 from "../../images/extraAd1.png";
import ad2 from "../../images/extraAd2.png";
import { Link } from "react-router-dom";

const ExtraAd = () => {
  return (
    <div className="mb-10">
      <p className="text-xl md:text-3xl font-medium font-sans text-gray-800 text-center">
        Stay Classic, Stay Breezy
      </p>
      <p className="text-center text-gray-500 text-sm md:text-base">
        Explore our Trendy Essentials
      </p>
      <div className="w-9 h-0.5 bg-red-600 mx-auto mt-4 md:mb-12 mb-6"></div>
      <div className="flex overflow-x-auto md:gap-4 scrollbar-hide">
        <Link to="/allproduct/SHIRTS">
          <img
            src={ad1}
            alt="ad1"
            className="min-w-full md:min-w-0 md:w-auto h-auto object-cover shadow-md hidden md:block"
          />
        </Link>
        <Link to="/allproduct/HOODIE">
          <img
            src={ad2}
            alt="ad2"
            className="min-w-full md:min-w-0 md:w-auto h-auto object-cover shadow-md "
          />
        </Link>
      </div>
    </div>
  );
};

export default ExtraAd;
